import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Tag.svg",
  "use": "Tag.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Tag.svg\"><path d=\"M47.5,12.0147l-13.5732.0045a6,6,0,0,0-4.2423,1.759L8.9137,34.5639a3.0087,3.0087,0,0,0,0,4.2533L25.2188,55.1354a3.0039,3.0039,0,0,0,4.25,0L50.2411,34.348a6,6,0,0,0,1.7559-4.24l.0047-13.5918A4.5,4.5,0,0,0,47.5,12.0147Zm-4.5236,12.04a3.0075,3.0075,0,1,1,3.005-3.0075A3.0062,3.0062,0,0,1,42.9763,24.0546Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol